import moment from "moment"
import { useState } from "react"
import { Modal } from "react-bootstrap"
import callAPI from "../../helpers/callAPI"
import CustomButton from "../../templates/UI/CustomButton/CustomButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ReactTooltip from "react-tooltip"
import { Link } from "react-router-dom/cjs/react-router-dom.min"


const APIBuilder = ({ showSystemMessage, isOpen, handleClose, api }) => {
    document.title = 'API Builder'

    const [isDisabled, setIsDisabled] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [clickIdDisabled, setClickIdDisabled] = useState(false)
    const [fetchMethod, setFetchMethod] = useState(api.fetch_method ? api.fetch_method : '')

    let createApi = false

    if (!api.id) {
        createApi = true
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        setSubmitting(true)

        const body = {
            name: e.target.name.value,
            endpoint: e.target.endpoint.value,
            fetchMethod: e.target.fetch_method.value,
            query: e.target.query.value,
            credential1: e.target.cred_1.value,
            credential2: e.target.cred_2.value,
            credential3: e.target.cred_3.value,
            mapNumberOfPages: e.target.num_of_pages.value,
            mapCurrentPage: e.target.current_page.value,
            recordsPerPage: e.target.static_records_per_page.value,
            mapRecordsPerPage: e.target.map_records_per_page.value,
            mapTotalRecords: e.target.map_total_records.value,
            apiStartDate: moment(e.target.start_date.value).format('YYYY-MM-DDTHH:mm:ss'),
            intervalType: e.target.interval_type.value,
            intervalValue: e.target.interval_value.value,
            disableLogging: e.target.disable_logging.value,
            result: e.target.result.value,
            clickIdDisabled: e.target.click_id_disabled.checked ? 'Y' : 'N',
            mapClickId: e.target.click_id.value,
            mapSaleAmount: e.target.sale_amount.value,
            mapLeadData: e.target.lead_data.value,
            mapTransactionDate: e.target.transaction_date.value,
            mapNetRate: e.target.net_rate.value,
            mapAffiliateId: e.target.affiliate_id.value,
            mapCampaignId: e.target.campaign_id.value,
            mapAPICampaignId: e.target.api_campaign_id.value,
            mapRateName: e.target.ratename.value,
            leadAcceptanceParamKey: e.target.acceptance_param_key.value,
            leadAcceptanceParamValue: e.target.acceptance_param_value.value,
            leadReversalParamValue: e.target.reversal_param_value.value,
            status: e.target.status.value,
            splitDelimiter: e.target.delimiter.value,
            mapSuccessKey: e.target.map_success_key.value,
            mapSuccessValue: e.target.map_success_value.value,
            headerName1: e.target.header1_name.value,
            headerValue1: e.target.header1_value.value,
            headerName2: e.target.header2_name.value,
            headerValue2: e.target.header2_value.value,
            lookbackDays: e.target.lookback_days.value,
            staticCampaignId: e.target.static_campaign_id.value,
            staticApiCampaignId: e.target.static_api_campaign_id.value,
            devNotes: e.target.dev_notes.value,
            postDataType: fetchMethod === 'POST' ? e.target.post_data_type.value : '',
            postData: fetchMethod === 'POST' ? e.target.post_data.value : '',
            dateFormat: e.target.date_format.value
        }

        callAPI(`apiBuilder/${createApi ? 0 : api.id}`, createApi ? 'POST' : 'PUT', body)
            .then(result => {
                if (result['success'] === true) {
                    showSystemMessage('success', result.message)
                    handleClose()
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                    setSubmitting(false)
                    return
                }
            }).catch(error => {
                setSubmitting(false)
                console.log(`Error while saving API details: ${error}`)
                showSystemMessage('error', 'An error occurred while saving API details')
            })
    }

    const handleOnChange = (e) => {
        e.preventDefault()
        if (e.target.name === 'fetch_method') {
            setFetchMethod(e.target.value)
        }
        setIsDisabled(false)
    }

    const handleClickIdDisabled = () => {
        setClickIdDisabled(!clickIdDisabled)
        setIsDisabled(false)
    }

    const IntervalOptions = () => {
        return (
            <select name="interval_type" className="form-control w-50 ml-3" onChange={handleOnChange} defaultValue={api.interval_type} ><option value="years">Year(s)</option>
                <option value="months">Month(s)</option>
                <option value="weeks">Week(s)</option>
                <option value="days">Day(s)</option>
                <option value="hours">Hour(s)</option>
                <option value="minutes">Minute(s)</option></select>
        )
    }

    // {
    //     "id": 7,
    //     "name": "API 6",
    //     "endpoint": "www.gmail.com",
    //     "map_click_id": "click",
    //     "map_sale_amount": "sale_amount",
    //     "map_lead_data": "lead_data",
    //     "map_net_rate": "net_rate",
    //     "map_commission_rate": "sale_amount",
    //     "map_affiliate_id": "affiliate_id",
    //     "map_offer_id": "campaign_id",
    //     "map_api_offer_id": "api_campaign_id",
    //     "map_ratename": "rate_name",
    //     "map_transaction_date": "transaction_date",
    //     "map_pages": "1",
    //     "map_records_per_page": "15",
    //     "map_total_records": "",
    //     "map_success_key": "status",
    //     "map_success_value": "Y",
    //     "static_offer_id": null,
    //     "static_records_per_page": 50,
    //     "credential1": "test",
    //     "credential2": "test",
    //     "credential3": "testing",
    //     "start_date": "2025-01-25T00:00:00.000Z",
    //     "interval_value": 1,
    //     "interval_type": "hours",
    //     "last_run_date": null,
    //     "next_run_date": null,
    //     "split_subid_delimiter": " ",
    //     "status": "A",
    //     "status_date": "2025-01-22T14:08:41.737Z",
    //     "db_date": "2025-01-22T14:08:41.737Z"
    // }

    return (
        <Modal show={isOpen} size="xl" onHide={handleClose}>
            <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>API Settings</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ReactTooltip />
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card mb-3">
                                <div className="card-header">
                                    API Information
                                </div>
                                <div className="card-body">
                                    <table className="table table-card table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td width="30%">API Name:</td>
                                                <td><input type="text" name="name" className="form-control w-75" onChange={handleOnChange} defaultValue={api.name} maxLength={20} required /></td>
                                            </tr>
                                            <tr>
                                                <td>Endpoint:</td>
                                                <td><textarea type="text" name="endpoint" className="form-control w-75" onChange={handleOnChange} defaultValue={api.endpoint} rows={6} required /></td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>
                                                    <div className="alert alert-secondary mt-2">
                                                        Macros:<br></br>
                                                        <code>
                                                            Start Date: #STARTDATE# (today - lookback days)<br></br>
                                                            End Date: #ENDDATE# (today)<br></br>
                                                            Credential 1: #CREDENTIAL1#<br></br>
                                                            Credential 2: #CREDENTIAL2#<br></br>
                                                            Credential 3: #CREDENTIAL3#<br></br>
                                                        </code>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Query:</td>
                                                <td className="d-flex align-items-center"><textarea type="text" name="query" className="form-control w-75" onChange={handleOnChange} defaultValue={api.graphql_query} /> <FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'For GraphQL only.'} /></td>
                                            </tr>
                                            <tr>
                                                <td>Lookback Days:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="lookback_days" className="form-control w-25" onChange={handleOnChange} defaultValue={api.lookback_days} /> <FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The #STARTDATE# macro will be equal to this many days back from today.'} /></td>
                                            </tr>
                                            <tr>
                                                <td>Date Format:</td>
                                                <td className="d-flex align-items-center"><input name="date_format" type="text" className="form-control w-75" onChange={handleOnChange} defaultValue={api.date_format} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The date format for API input. Defaults to YYYY-MM-DD.'} /></td>
                                            </tr>
                                            <tr>
                                                <td>Fetch Method:</td>
                                                <td>
                                                    <select name="fetch_method" className="form-control w-50"
                                                        onChange={handleOnChange}
                                                        defaultValue={api.fetch_method}
                                                        required>
                                                        <option value="GET">GET</option>
                                                        <option value="POST">POST</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            {fetchMethod === 'POST' && <><tr>
                                                <td>Post Data Type:</td>
                                                <td>
                                                    <select name="post_data_type" className="form-control w-50"
                                                        onChange={handleOnChange}
                                                        defaultValue={api.post_data_type?.trim()}
                                                        required={fetchMethod === 'POST' ? true : false}
                                                    >
                                                        <option value="JSON">JSON</option>
                                                        <option value="formdata">FormData</option>
                                                    </select>
                                                </td>
                                            </tr>
                                                <tr>
                                                    <td>Post Data</td>
                                                    <td>
                                                        <textarea type="text" name="post_data" className="form-control w-75" onChange={handleOnChange} defaultValue={api.post_data} rows={6} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <div className="alert alert-secondary mt-2">
                                                            Post Body:<br></br>
                                                            <code>
                                                                &#123; "key1": "value1", "key2": "value2" &#125;
                                                            </code>
                                                            <br /> <br />
                                                            The MACROS listed above can be used in Post Data.
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>}
                                            <tr>
                                                <td>Status:</td>
                                                <td>
                                                    <select name="status" className="form-control w-50" onChange={handleOnChange} defaultValue={api.status} required>
                                                        <option value=""></option>
                                                        <option value="A">Active</option>
                                                        <option value="C">Cancelled</option>
                                                        <option value="T">Testing</option>
                                                    </select>
                                                    {
                                                        api.status == 'T' ?
                                                            <Link target="_blank" to={`/apiLeadsReportTesting`}>View Test Conversions Pulled</Link>
                                                            :
                                                            <Link target="_blank" to={`/apiLeadsReport`}>View Live Conversions Pulled</Link>
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Credential 1:</td>
                                                <td><input type="text" name="cred_1" className="form-control w-75" onChange={handleOnChange} defaultValue={api.credential1} /></td>
                                            </tr>
                                            <tr>
                                                <td>Credential 2:</td>
                                                <td><input type="text" name="cred_2" className="form-control w-75" onChange={handleOnChange} defaultValue={api.credential2} /></td>
                                            </tr>
                                            <tr>
                                                <td>Credential 3:</td>
                                                <td><input type="text" name="cred_3" className="form-control w-75" onChange={handleOnChange} defaultValue={api.credential3} /></td>
                                            </tr>
                                            <tr className="border-top">
                                                <td>Header1 Name:</td>
                                                <td><input type="text" name="header1_name" className="form-control w-75" onChange={handleOnChange} defaultValue={api.header_name1} /></td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <td>Header1 Value:</td>
                                                <td><input type="text" name="header1_value" className="form-control w-75" onChange={handleOnChange} defaultValue={api.header_value1} /></td>
                                            </tr>
                                            <tr className="border-top">
                                                <td>Header2 Name:</td>
                                                <td><input type="text" name="header2_name" className="form-control w-75" onChange={handleOnChange} defaultValue={api.header_name2} /></td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <td>Header2 Value:</td>
                                                <td><input type="text" name="header2_value" className="form-control w-75" onChange={handleOnChange} defaultValue={api.header_value2} /></td>
                                            </tr>
                                            <tr>
                                                <td>Start Date:</td>
                                                <td className="d-flex align-items-center"><input type="datetime-local" name="start_date" className="form-control w-75" onChange={handleOnChange} defaultValue={moment(api.start_date).utc().format('YYYY-MM-DD HH:mm:ss')} required step="any" /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The baseline date used to calculate how often this API job runs.'} /></td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <td>Interval:</td>
                                                <td className="d-flex align-items-center">Every <input type="number" name="interval_value" className="form-control ml-3 w-25" defaultValue={api.interval_value} onChange={handleOnChange} /><IntervalOptions /></td>
                                            </tr>
                                            <tr>
                                                <td>Disable Logging:</td>
                                                <td>
                                                    <select className="form-control w-50" onChange={handleOnChange} name="disable_logging">
                                                        <option value=""></option>
                                                        <option value="Y">Yes</option>
                                                        <option value="N">No</option>
                                                    </select></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    Static Settings
                                </div>
                                <div className="card-body">
                                    <table className="table table-card table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td>Records Per Page:</td>
                                                <td><input type="text" name="static_records_per_page" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_static_records_per_page} /></td>
                                            </tr>
                                            <tr>
                                                <td>Campaign ID:</td>
                                                <td><input type="text" name="static_campaign_id" className="form-control w-75" onChange={handleOnChange} defaultValue={api.static_offer_id} /></td>
                                            </tr>
                                            <tr>
                                                <td>Static API Campaign ID:</td>
                                                <td><input type="text" name="static_api_campaign_id" className="form-control w-75" onChange={handleOnChange} defaultValue={api.static_api_offer_id} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card mb-3">
                                <div className="card-header">
                                    Response Mapping
                                </div>
                                <div className="card-body">
                                    <table className="table table-card table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td>Result:</td>
                                                <td className="d-flex align-items-center">
                                                    <input type="text" name="result" onChange={handleOnChange} className="form-control w-75" defaultValue={api.map_result} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The location of the array/list of conversions within the response. Use a [.] to move through the object. Example: parent.child.conversions'} />
                                                </td>
                                            </tr>
                                            <tr className="border-top">
                                                <td>Success Key:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="map_success_key" className="form-control w-75" onChange={handleOnChange} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'Only needed if the API can let us know whether or not the request succeeded or failed.'} /></td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <td>Success value:</td>
                                                <td><input type="text" name="map_success_value" className="form-control w-75" onChange={handleOnChange} /></td>
                                            </tr>
                                            <tr className="border-top">
                                                <td>Click ID Disabled <div className="badge badge-info">setting</div>:</td>
                                                <td className="d-flex align-items-center">
                                                    <input type="checkbox" name="click_id_disabled" onChange={handleClickIdDisabled} defaultChecked={api.click_id_disabled === 'Y'} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'If we are not receiving a click ID at all, check thix box and leave the Click ID field blank.'} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="30%">Click ID:</td>
                                                <td><input type="text" name="click_id" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_click_id} disabled={clickIdDisabled} required={!clickIdDisabled} /></td>
                                            </tr>
                                            <tr>
                                                <td>Affiliate ID:</td>
                                                <td><input type="text" name="affiliate_id" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_affiliate_id} /></td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <td>Delimiter <div className="badge badge-info">setting</div>:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="delimiter" className="form-control w-75" onChange={handleOnChange} defaultValue={api.split_subid_delimiter ? api.split_subid_delimiter.trim() : ''} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The symbol that separates two values. Example: _ to separate #MBID#_#ACID#. Example, if the map value for click ID and affiliate ID is SUB1, use SUB1[0] for the MBID and SUB1[1] for the ACID.'} /></td>
                                            </tr>
                                            <tr>
                                                <td>Sale Amount:</td>
                                                <td><input type="text" name="sale_amount" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_sale_amount} required /></td>
                                            </tr>
                                            <tr>
                                                <td>Lead Data:</td>
                                                <td><input type="text" name="lead_data" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_lead_data} required /></td>
                                            </tr>
                                            <tr>
                                                <td>Transaction Date:</td>
                                                <td><input type="text" name="transaction_date" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_transaction_date} required /></td>
                                            </tr>
                                            <tr>
                                                <td>Net Rate:</td>
                                                <td><input type="text" name="net_rate" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_net_rate} required /></td>
                                            </tr>
                                            <tr>
                                                <td>Campaign ID:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="campaign_id" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_offer_id} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'If they can pass us back our MB campaign ID. In most cases they cannot.'} /></td>
                                            </tr>
                                            <tr>
                                                <td>API campaign ID:</td>
                                                <td><input type="text" name="api_campaign_id" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_api_offer_id} /></td>
                                            </tr>
                                            <tr>
                                                <td>Ratename:</td>
                                                <td><input type="text" name="ratename" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_ratename} /></td>
                                            </tr>
                                            <tr className="border-top">
                                                <td>Lead Acceptance Parameter Key:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="acceptance_param_key" className="form-control w-75" placeholder="Separate by comma if multiple" onChange={handleOnChange} defaultValue={api.lead_acceptance_param_key} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The key indicating the status for the conversion. Example: Status'} /></td>
                                            </tr>
                                            <tr>
                                                <td>Lead Acceptance Parameter Value:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="acceptance_param_value" className="form-control w-75" placeholder="Separate by comma if multiple" onChange={handleOnChange} defaultValue={api.lead_acceptance_param_value} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The values we want to pull in as payable. Example: Payable, Pending'} /></td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <td>Lead Reversal Parameter Value:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="reversal_param_value" className="form-control w-75" placeholder="Separate by comma if multiple" onChange={handleOnChange} defaultValue={api.lead_reversal_param_value} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The values that indicate reversal. Example: Reversed, Cancelled'} /></td>
                                            </tr>
                                            <tr>
                                                <td>Number of Pages:</td>
                                                <td><input type="text" name="num_of_pages" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_pages} /></td>
                                            </tr>
                                            <tr>
                                                <td>Current Page:</td>
                                                <td><input type="text" name="current_page" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_current_page} /></td>
                                            </tr>
                                            <tr>
                                                <td>Records Per Page:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="map_records_per_page" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_records_per_page} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The values that indicate the records per page.'} /></td>
                                            </tr>
                                            <tr>
                                                <td>Total Records:</td>
                                                <td className="d-flex align-items-center"><input type="text" name="map_total_records" className="form-control w-75" onChange={handleOnChange} defaultValue={api.map_total_records} /><FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={'The values that indicate the total number of items(leads) in an incoming response.'} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    Extra Info
                                </div>
                                <div className="card-body">
                                    <table className="table table-card table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td>Notes:</td>
                                                <td><textarea type="text" name="dev_notes" className="form-control w-75" onChange={handleOnChange} defaultValue={api.dev_notes} rows={6} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <CustomButton name={createApi ? "Save" : "Update"} variant="success" type="submit" disabled={isDisabled} spin={submitting} />
                </Modal.Footer>
            </form>
        </Modal>
    )
}

export default APIBuilder